import { Typography } from "@mui/material";

export default function BetoniOnlinePrintBanner() {
  return (
    <div className="onlyPrint harmaaTausta">
      <Typography color="primary" className="fixPrint" sx={{ opacity: 0.7 }} align="center">
        betoni.online
      </Typography>
    </div>
  );
}
